import apiClient from "./apiClient";

const BASE = "/api/Procedure";

// API returns procedureID (no `id`) — alias it so list/edit/delete code using `.id` works.
const withId = (p) => ({ ...p, id: p.procedureID });

export const getProcedures = async () => {
  const res = await apiClient.get(`${BASE}/all`);
  return { ...res, data: (res.data || []).map(withId) };
};
export const getActiveProcedures = async () => {
  const res = await apiClient.get(`${BASE}/active`);
  return { ...res, data: (res.data || []).map(withId) };
};
export const getProcedure = (id) => apiClient.get(`${BASE}/${id}`);
export const createProcedure = (data) => apiClient.post(`${BASE}/save`, data);
export const updateProcedure = (id, data) => apiClient.post(`${BASE}/save`, { ...data, procedureID: id });
export const deleteProcedure = (id) => apiClient.delete(`${BASE}/${id}`);
